export enum ForumRef {
	NewReplies = 'New Replies',
	Trending = 'Trending',
	ForumsAndTopics = 'Forums & Topics',
	ForumComments = 'Forums Comments',
}
